<template>
  <div>
    <el-select
      v-model="zoneId"
      filterable
      :disabled="disabled"
      :placeholder="placeholder"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      zoneId: "", // 当前被选择的分区id
      availableZones: [], // 所有可用的分区
    };
  },

  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },

    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },

    // 是否支持选择“全大区”
    enableFullZones: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    options() {
      let options = [];

      if (this.enableFullZones) {
        options.push({
          id: 0,
          name: "所有分区",
        });
      }

      for (let c of this.availableZones) {
        options.push({
          id: c.id,
          name: `${c.id}区-${c.name}`,
        });
      }

      return options;
    },
  },

  created() {
    this.loadAvailableZones();
  },

  watch: {
    zoneId: {
      handler(newValue, oldValue) {
        this.$emit("change", newValue, oldValue);
      },
    },
  },

  methods: {
    /**
     * 查询分区集合
     */
    async loadAvailableZones() {
      this.availableZones = await bizutil.loadAvailableZones();

      // 抛出准备就绪事件
      this.$emit("ready");
    },
  },
};
</script>